import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSololearnComponent } from './simple-icons-sololearn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSololearnComponent ],
    exports:      [ SimpleIconsSololearnComponent ],
    bootstrap:    []
})
export class SimpleIconsSololearnModule {}
